import { FETCH_PASSBOOK_DATA, SET_PASSBOOK_DATA } from './constants';

export const fetchTransactions = (payload: {
  pageNo: string;
  pageSize: number;
  transactionType: string;
  vehicleId: string;
  reset: boolean;
  fromTime: string;
  toTime: string;
  fetchMore?: boolean;
}) => {
  const { pageNo, pageSize = 20, fromTime, toTime, reset = true, fetchMore = false } = payload;
  const requestParam: any = {};
  const params = [];
  if (pageNo) {
    params.push(`pageNo=${pageNo}`);
  }
  if (fromTime) {
    params.push(`fromTime=${fromTime}`);
  }
  if (fromTime) {
    params.push(`toTime=${toTime}`);
  }
  params.push(`pageSize=${pageSize}`);
  requestParam.query = params.join('&');
  requestParam.reset = reset;
  requestParam.fetchMore = fetchMore;
  return {
    type: FETCH_PASSBOOK_DATA,
    data: requestParam,
  };
};

export const setTxnDetails = (data: any) => ({
  type: SET_PASSBOOK_DATA,
  data,
});
